/* @ngInject */
function ApprovalMessageController ($scope, UserService, AssetService, AssetPreviewService) {
  $scope.flags = {
    loadingAsset: false
  }

  $scope.getAvatarUrl = (userId) => {
    return UserService.getUserProfileImage(userId)
  }

  $scope.openAttachment = (assetId) => {
    $scope.flags.loadingAsset = true
    AssetService.getAssetDetailsById(assetId).then(asset => {
      $scope.flags.loadingAsset = false
      AssetPreviewService.openAssetPreview({
        asset: asset,
        task: $scope.task,
        location: 'workflow'
      })
    })
  }

  $scope.showSeeAttachmentButton = () => {
    return $scope.asset.id && $scope.showSeeAttachment
  }
}

export { ApprovalMessageController }
